import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { setCheckLists, setTimesheets, setWhichDocument, SupportSheetSelector } from './reducers/SupportSheetReducer';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { Button, Grid, TextField } from '@mui/material';
import { CheckList, CheckListHistoryItem, SupportSheetStatus } from './models/SupportSheetModel';
import { SupportSheetCheckListConstant } from './models/SupportSheetCheckListConstant';
import { SupportSheetHelpTextConstant } from './models/SupportSheetHelperTextConstant';
import { portSelectorSelector } from '../PortSelector/reducers/PortSelectorReducer';
import SupportSheetHelpText from './components/SupportSheetHelpText/SupportSheetHelpText';
import SupportSheetTimesheet, { getDefaultTimeSheet } from './components/SupportSheetTimeSheet/SupportSheetTimesheet';
import SupportSheetTimesheetModel from './components/SupportSheetTimeSheet/models/SupportSheetTimesheetModel';
import SupportSheetCustomCheckbox from './components/SupportSheetCustomCheckbox/SupportSheetCustomCheckbox';
import EmailEditorModel from '../EmailEditorModal/models/EmailEditorModel';
import { SupportSheetEmailContentConstant } from './models/SupportSheetEmailContentConstant';
import Utility from '../../app/utility';
import { setEmailSendAfterAgree, setHelperText, setShowEmailAfterOk, setShowHelperTextModal, setTitle } from './components/SupportSheetHelpText/reducers/SupportSheetHelpTextReducer';
import { contructEmailSubjectPrefix, hasError } from './SupportSheetBiefInformation';
import { PopupEmail } from './SupportSheetPreVoyage';

const SupportSheetOnVoyageVOY: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);
    const portSelectorData = useSelector(portSelectorSelector);

    const isDontFollowShipment = () => {
        return supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['We dont follow this shipment']) > -1 : false;
    }

    const getTimeSheetHtmlForEmail = () => {
        let timesheets = supportSheetData.model.timesheets ? JSON.parse(supportSheetData.model.timesheets) as SupportSheetTimesheetModel[] : [];

        let html = "";
        _.each(timesheets, (item: SupportSheetTimesheetModel) => {
            if (item.date.length > 0 || item.vesselStatus.length > 0) {
                html += `${item.date.toUpperCase()}: ${item.vesselStatus.toUpperCase()}\n`
            }
        });

        return html;
    };

    const updateCheckList = (checkListName: string, isAdded: boolean) => {
        let checkList = supportSheetData.model.checkLists ? JSON.parse(supportSheetData.model.checkLists) as CheckList :
            {
                checkListItems: [],
                history: []
            } as CheckList;

        if (isAdded) {
            checkList.checkListItems.push(checkListName);

            //history
            let index = _.findIndex(checkList.history, (item) => {
                return item.name === checkListName;
            });

            if (index === -1) {
                checkList.history.push({
                    name: checkListName.replace(".", ""),
                    date: new Date().toISOString()
                } as CheckListHistoryItem)
            }
        } else {
            let removeIndex = _.indexOf(checkList.checkListItems, checkListName);
            checkList.checkListItems.splice(removeIndex, 1);
        }

        dispatch(setCheckLists(JSON.stringify(checkList)));
    }

    const errorTimesheetClassName = (enableValidation: boolean, value: string, isDontFollowShipment: boolean) => {
        if (isDontFollowShipment) {
            return "";
        }

        if (enableValidation) {
            if (!value || value.length == 0) {
                return "support-sheet-red-text-error";
            }

            let timeSheets = JSON.parse(value) as SupportSheetTimesheetModel[];
            let hasTimesheet = false;
            _.each(timeSheets, (timesheet) => {
                if (timesheet.date.length > 0 && timesheet.vesselStatus.length > 0) {
                    hasTimesheet = true;
                }
            })

            return hasTimesheet ? "" : "support-sheet-red-text-error";

        }
        return "";
    }

    return (
        <>
            <CustomAccordion
                title="On Voyage"
                defaultOpen={true}
                open={supportSheetData.model.status == SupportSheetStatus.PreArrivalLoadPort ||
                    supportSheetData.model.status == SupportSheetStatus.OnVoyage ||
                    supportSheetData.model.status == SupportSheetStatus.PendingLayTimeLTC ||
                    supportSheetData.model.status == SupportSheetStatus.PendingCommission ||
                    supportSheetData.model.status == SupportSheetStatus.Cancel ||
                    supportSheetData.model.status == SupportSheetStatus.PendingDisputes
                }
                onOpenChange={(isOpen: boolean) => {
                }}
            >
                <Grid container>
                    <Grid item xs={5}>
                        <div>
                            <Button variant='outlined' color='primary'
                                disabled={isDontFollowShipment()}
                                onClick={() => {
                                    if (supportSheetData.ownerBrokerContactPrinciple) {
                                        PopupEmail({
                                            emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                            emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                            emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE",
                                            emailContent: (() => {
                                                let brokerReminder = supportSheetData.model.brokerReminder ?
                                                    `Brokers' reminder:\r\nLaycan: ${Utility.DateFormat.formatDateString(supportSheetData.model.lay)} - ${Utility.DateFormat.formatDateString(supportSheetData.model.can)}` :
                                                    "";

                                                return SupportSheetEmailContentConstant["Ask owners for update"] +
                                                    `\n\n${brokerReminder}`
                                            })(),
                                            receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                        } as EmailEditorModel, supportSheetData.brokerEmails);
                                    } else {
                                        Utility.Alert.Error("Please select owner principle before sending email");
                                    }
                                }}
                            >
                                Ask owners for update
                            </Button>
                            <SupportSheetHelpText
                                helpText={SupportSheetHelpTextConstant['Ask owners for update']}
                            ></SupportSheetHelpText>
                            <Button variant='outlined' color='primary'
                                disabled={isDontFollowShipment()}
                                onClick={() => {
                                    if (supportSheetData.chartererBrokerContactPrinciple) {
                                        PopupEmail({
                                            emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                            emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                            emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE",
                                            emailContent: (() => {
                                                let brokerReminder = supportSheetData.model.brokerReminder ?
                                                    `Brokers' reminder:\r\nLaycan: ${Utility.DateFormat.formatDateString(supportSheetData.model.lay)} - ${Utility.DateFormat.formatDateString(supportSheetData.model.can)}` :
                                                    "";

                                                return "Please find below vsl update from ownrs fyr:\n\n" +
                                                    `MV ${supportSheetData.currentFixture.tonnageVesselName}\n\n` +
                                                    `${getTimeSheetHtmlForEmail()}\n` +
                                                    `${brokerReminder}`
                                            })(),
                                            receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                        } as EmailEditorModel, supportSheetData.brokerEmails);
                                    } else {
                                        Utility.Alert.Error("Please select owner principle before sending email");
                                    }
                                }}
                            >
                                Update to Charterers
                            </Button>
                            <SupportSheetHelpText
                                helpText={SupportSheetHelpTextConstant['Update to Charterers']}
                            ></SupportSheetHelpText>
                        </div>
                    </Grid>
                    <Grid item xs={7}>

                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={5}>
                        <SupportSheetTimesheet
                            items={!supportSheetData.model.timesheets || supportSheetData.model.timesheets.length == 0 ? getDefaultTimeSheet() : JSON.parse(supportSheetData.model.timesheets) as SupportSheetTimesheetModel[]}
                            onChange={(items: SupportSheetTimesheetModel[]) => {
                                dispatch(setTimesheets(JSON.stringify(items)));
                            }}
                            disabled={isDontFollowShipment()}
                            errorClassName={errorTimesheetClassName(supportSheetData.enableValidation, supportSheetData.model.timesheets, isDontFollowShipment())}
                        ></SupportSheetTimesheet>
                    </Grid>
                    <Grid item xs={7}>
                        <div><b>Remarks</b></div>
                        <div>
                            During the whole shipment from handover date till completion of discharging, make sure follow up vsl's movement closely on daily basis. In case sub vessel may miss laycan, please notice Manager/brokers.
                        </div>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check if loadport agent has been appointed']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check if loadport agent has been appointed'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Check if loadport agent has been appointed']}
                            helpText={SupportSheetHelpTextConstant['Check if loadport agent has been appointed']}
                            checkboxText={'Check if loadport agent has been appointed'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "LOADPORT AGENT APPOINTMENT",
                                        emailContent: SupportSheetEmailContentConstant["Check if loadport agent has been appointed"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Obtain prestowage plan']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Obtain prestowage plan'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Obtain prestowage plan']}
                            helpText={SupportSheetHelpTextConstant['Obtain prestowage plan']}
                            checkboxText={'Obtain prestowage plan'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['When sub vsl arrives loadport, obtain NOR and send to Chtrs']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['When sub vsl arrives loadport, obtain NOR and send to Chtrs'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['When sub vsl arrives loadport, obtain NOR and send to Chtrs']}
                            helpText={SupportSheetHelpTextConstant['When sub vsl arrives loadport, obtain NOR and send to Chtrs']}
                            checkboxText={'When sub vsl arrives loadport, obtain NOR and send to Chtrs'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE",
                                        emailContent: SupportSheetEmailContentConstant["When sub vsl arrives loadport, obtain NOR and send to Chtrs"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['During loading, obtain draft BL and get Chtrs Owners confirmation.']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['During loading, obtain draft BL and get Chtrs Owners confirmation.'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['During loading, obtain draft BL and get Chtrs Owners confirmation.']}
                            helpText={SupportSheetHelpTextConstant['During loading, obtain draft BL and get Chtrs Owners confirmation.']}
                            checkboxText={'During loading, obtain draft BL and get Chtrs\'/Owners confirmation.'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE",
                                        emailContent: SupportSheetEmailContentConstant["During loading, obtain draft BL and get Chtrs Owners confirmation."],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check if Disport agent has been appointed?']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check if Disport agent has been appointed?'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Check if Disport agent has been appointed?']}
                            helpText={SupportSheetHelpTextConstant['Check if Disport agent has been appointed?']}
                            checkboxText={'Check if Disport agent has been appointed?'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "DISPORT AGENT APPOINTMENT",
                                        emailContent: SupportSheetEmailContentConstant["Check if Disport agent has been appointed?"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner broker before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs.']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs.'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs.']}
                            helpText={SupportSheetHelpTextConstant['When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs.']}
                            checkboxText={'When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs.'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "FREIGHT PAYMENT + LOADING DOCS",
                                        emailContent: SupportSheetEmailContentConstant["When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs."],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Send freight invoice to Chtrs (please remember to verify bank account)']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Send freight invoice to Chtrs (please remember to verify bank account)'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Send freight invoice to Chtrs (please remember to verify bank account)']}
                            helpText={SupportSheetHelpTextConstant['Send freight invoice to Chtrs (please remember to verify bank account)']}
                            checkboxText={'Send freight invoice to Chtrs <span class="support-sheet-red-text">(please remember to verify bank account)</span>'}
                            helpTextTitle={'Send freight invoice to Chtrs'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    dispatch(setTitle("Please remember to verify bank account"));
                                    dispatch(setHelperText(SupportSheetHelpTextConstant["Please remember to verify bank account"]));
                                    dispatch(setEmailSendAfterAgree({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "FREIGHT PAYMENT",
                                        emailContent: SupportSheetEmailContentConstant["Send freight invoice to Chtrs (please remember to verify bank account)"],
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel))
                                    dispatch(setShowEmailAfterOk(true));

                                    dispatch(setShowHelperTextModal(true));
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check cargo will be discharged/released at disport against?']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check cargo will be discharged/released at disport against?'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Check cargo will be discharged/released at disport against?']}
                            helpText={SupportSheetHelpTextConstant['Check cargo will be discharged/released at disport against?']}
                            checkboxText={''}
                            showSendEmail={true}
                            htmlBeforeText={
                                <>
                                    <span className={(isDontFollowShipment() ? "email-disable" : "")}>
                                        Check cargo will be discharged/released at disport against?
                                    </span>
                                    <span className='support-sheet-chtrs-owners'>
                                        <TextField
                                            label="Which Document"
                                            disabled={isDontFollowShipment()}
                                            fullWidth
                                            value={supportSheetData.model.whichDocument ? supportSheetData.model.whichDocument : ""}
                                            onChange={(event) => {
                                                dispatch(setWhichDocument(event.target.value));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.whichDocument)
                                            }
                                            className='cargo-input-component'
                                        />
                                    </span>
                                </>
                            }
                            onEmailClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "CARGO DISCHARGING",
                                        emailContent: SupportSheetEmailContentConstant["Check cargo will be discharged/released at disport against?"],
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Obtained that doc and send to Owners.']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Obtained that doc and send to Owners.'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Obtained that doc and send to Owners.']}
                            helpText={SupportSheetHelpTextConstant['Obtained that doc and send to Owners.']}
                            checkboxText={'Obtained that doc and send to Owners.'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Obtain bank slip from Charterers and send to Owners.']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Obtain bank slip from Charterers and send to Owners.'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Obtain bank slip from Charterers and send to Owners.']}
                            helpText={SupportSheetHelpTextConstant['Obtain bank slip from Charterers and send to Owners.']}
                            checkboxText={'Obtain bank slip from Charterers and send to Owners.'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "FREIGHT PAYMENT",
                                        emailContent: SupportSheetEmailContentConstant["Obtain bank slip from Charterers and send to Owners."],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Owners received payment?']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Owners received payment?'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Owners received payment?']}
                            helpText={SupportSheetHelpTextConstant['Owners received payment?']}
                            checkboxText={'Owners received payment?'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "FREIGHT PAYMENT",
                                        emailContent: SupportSheetEmailContentConstant["Owners received payment?"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['When sub vsl arrives disport, obtain NOR and send to Chtrs']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['When sub vsl arrives disport, obtain NOR and send to Chtrs'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['When sub vsl arrives disport, obtain NOR and send to Chtrs']}
                            helpText={SupportSheetHelpTextConstant['When sub vsl arrives disport, obtain NOR and send to Chtrs']}
                            checkboxText={'When sub vsl arrives disport, obtain NOR and send to Chtrs'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE",
                                        emailContent: SupportSheetEmailContentConstant["When sub vsl arrives disport, obtain NOR and send to Chtrs"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['After completion of discharging, obtain cargo docs and send to Chtrs']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['After completion of discharging, obtain cargo docs and send to Chtrs'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['After completion of discharging, obtain cargo docs and send to Chtrs']}
                            helpText={SupportSheetHelpTextConstant['After completion of discharging, obtain cargo docs and send to Chtrs']}
                            checkboxText={'After completion of discharging, obtain cargo docs and send to Chtrs'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "CARGO DOCS",
                                        emailContent: SupportSheetEmailContentConstant["After completion of discharging, obtain cargo docs and send to Chtrs"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                    </Grid>
                </Grid>
            </CustomAccordion>
        </>
    )
};

export default SupportSheetOnVoyageVOY;